import React from "react";
import ContactCard from "./ContactCard";
import contactImg1 from "../../../images/contact-img-1.jpg";
import contactImg2 from "../../../images/contact-img-2.jpg";
import contactImg3 from "../../../images/contact-img-3.jpg";
import contactImg4 from "../../../images/contact-img-4.jpg";
import contactImg5 from "../../../images/contact-img-5.jpg";
import "../Cards.css";

function ContactCardGrid() {
  return (
    <div className="contacts">
      <div className="contacts-custom">
        <ContactCard
          contactImg={contactImg1}
          contactSurname="Ryazanov" // Рязанов
          contactName="Roman" // Роман
          contactSecondName="Nikolaevich" // Николаевич
          // Директор ООО «Интеллект-Развитие-Технологии»
          contactJob="Director of Intellect-Development-Technologies LLC"
          contactEmail="RRyazanov@i-d-tech.com"
          // contactTel="+7(922)478-38-33"
        />
        <ContactCard
          contactImg={contactImg2}
          contactSurname="Yastrebov" // Ястребов
          contactName="Ilya" // Илья
          contactSecondName="Dinarovich" // Динарович
          // Заместитель директора
          contactJob="Deputy Director"
          contactEmail="IDYastrebov@i-d-tech.com"
          // contactTel="+7(912)927-62-55"
        />
        <ContactCard
          contactImg={contactImg3}
          contactSurname="Suleimanov" // Сулейманов
          contactName="Ramis" // Рамис
          contactSecondName="Robertovich" // Робертович
          // Руководитель направления «РИР»
          contactJob="Head of Repair and Insulation Works Department"
          contactEmail="RRSuleimanov@i-d-tech.com"
          // contactTel="+7(952)677-51-02"
        />
        <ContactCard
          contactImg={contactImg4}
          contactSurname="Murashko" // Мурашко
          contactName="Alexander" // Александр
          contactSecondName="Evgenievich" // Евгеньевич
          // Руководитель направления разработки ПО
          contactJob="Head of Software Development Department"
          contactEmail="AEMurashko@i-d-tech.com"
          // contactTel="+7(904)476-49-88"
        />
        <ContactCard
          contactImg={contactImg5}
          contactSurname="Biletnikov" // Билетников
          contactName="Egor" // Егор
          contactSecondName="Yurievich" // Юрьевич
          // Руководитель направления «Инженерное сопровождение»
          contactJob="Head of Engineering Support Department"
          contactEmail="EYuBiletnikov@i-d-tech.com"
          // contactTel="+7(922)483-92-33"
        />
      </div>
    </div>
  );
}

export default ContactCardGrid;
